import { DefaultNumberOption } from "./DefaultNumberOption.mjs";
function GetNumberOption(options, property, minimum, maximum, fallback) {
  var val = options[property];
  return DefaultNumberOption(val, minimum, maximum, fallback);
}
export {
  GetNumberOption
};
